<div
  class="thinking-loader"
  role="status"
  aria-live="polite"
  [attr.aria-label]="label || 'Thinking'">
  <span class="thinking-letter" style="--i: 0">t</span>
  <span class="thinking-letter" style="--i: 1">h</span>
  <span class="thinking-letter" style="--i: 2">i</span>
  <span class="thinking-letter" style="--i: 3">n</span>
  <span class="thinking-letter" style="--i: 4">k</span>
  <span class="thinking-letter" style="--i: 5">i</span>
  <span class="thinking-letter" style="--i: 6">n</span>
  <span class="thinking-letter" style="--i: 7">g</span>
</div>
